export default {
	"deviceManage": {
		"transfer": "转交",
		"recycling": "回收",
		"chooseDeviceNumber": "选择设备编号",
		"deviceLibrary": "设备库",
		"adminrole": "管理员",
		"platform": "平台",
		"useMan": "使用人",
		"stakeholders": "当前干系人",
		"department": "所属部门",
		"gpsTime": "最新跟踪时间",
		"offlineTime": "离线时长",
		"equipmentStatus": "设备状态",
		"dumpEnergy": "剩余电量",
		"lat": "跟踪",
		"lng": "请选择地址",
		"deviceInfo": "设备信息",
		"equipmentNo": "设备编码",
		"equipmentCode": "设备条码",
		"cityName": "所在城市",
		"statusStartDt": "状态开始时间",
		"duration": "持续时间",
		"routeNos": "当前跟踪单据",
		"useHistory": "使用历史",
		"type": "类型",
		"addDeviceInfo": "添加管理设备",
		"transferAdmin": "转交管理人",
		"transferTakeholders": "当前管理人",
		"equipmentLocation": "设备定位",
		"importDevice": "导入设备",
		"tipsSelectManager": "请选择当前管理人",
		"tipsTransferSuccess": "转交成功",
		"tipsCannotRecycle": "不可回收“使用中”状态的设备。",
		"tipsSelectRecycle": "请选择一项需要回收的数据。",
		"tipsConfirmRecycle": "确定要回收吗"
	},
	"machine": {
		"mapMonitor": "地图监控",
		"lastStateInfo": "最新状态信息",
		"lastTime": "最新时间",
		"machineState": "运行状态",
		"doorState": "门磁状态",
		"conditioningState": "空调状态",
		"engineState": "发动机状态",
		"speed": "速度",
		"altitude": "海拔",
		"bearing": "方位"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/machine/machine.js